/**
 * const css = styleBreakpoints({ fullWidth: 1400, fullHeight: 1100 }, scale => {
 *   return `
 *     .foo {
 *       font-size: ${scale*16}px;
 *     }
 *   `
 * })
 */
export default function styleBreakpoints({ fullWidth, fullHeight, increment = 10 }, createStyles) {
  console.assert(typeof fullWidth === 'number')
  console.assert(typeof fullHeight === 'number')
  console.assert(typeof increment === 'number')
  console.assert(typeof createStyles === 'function')

  const style = []
  let i = 0
  for (let height = fullHeight; height > 0; height -= increment) {
    const scale = height / fullHeight
    style[i] = `
    @media (max-height: ${height}px) and (min-height: ${height-increment}px) {
      ${createStyles(scale)}
    }
  `
    i += 2
  }

  i = 1
  for (let width = fullWidth; width > 0; width -= increment) {
    const scale = width / fullWidth
    style[i] = `
      @media (max-width: ${width}px) and (min-width: ${width-increment}px) {
        ${createStyles(scale)}
      }
    `
    i += 2
  }

  const css = style.filter(x => x).join('\n')

  return css
}



// WEBPACK FOOTER //
// ./src/styleBreakpoints.js